
import { ArrowRightIcon } from "@heroicons/vue/24/solid";
import { Stream } from "@oculai/planner";
import { PropType } from "vue";

export default {
  name: "StreamCardArchive",
  props: {
    stream: {
      type: Object as PropType<Stream>,
      required: true,
    },
  },
  components: {
    ArrowRightIcon,
  },
  data() {
    return {
      missingThumbnail: false,
    };
  },
};
